import React, { useState, useContext } from "react";
import axios from "../../../../../axios/index";

// context
import { UserContext } from "../../../../Context/UserContextProvider";

import { useHistory } from "react-router-dom";

// components
import { Form } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { removeCommas } from "@persian-tools/persian-tools";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Styles
import styles from "./ConsultantReportsExpertReportDetails.module.css";
import Dstyles from "../../../DashboardFileManagement/DashboardFileManagement.module.css";

const AddConsultantReportsExpertReportForm = ({ formValue, setFormValue, errors, id }) => {
  const { userToken } = useContext(UserContext);
  const [btnLoader, setBtnLoader] = useState(false);
  const history = useHistory();

  const formChangeHandler = e => {
    if (e.target.name === "price") {
      setFormValue(prev => {
        return { ...prev, [e.target.name]: removeCommas(e.target.value) };
      });
    } else {
      setFormValue(prev => {
        return { ...prev, [e.target.name]: e.target.value };
      });
    }
  };

  const selectDateChangeHandler = value => {
    setFormValue(prev => {
      return { ...prev, date: value };
    });
  };

  const selectTimeChangeHandler = value => {
    setFormValue(prev => {
      return { ...prev, time: value };
    });
  };

  const addCommas = num => num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const removeNonNumeric = num => num?.toString().replace(/[^0-9]/g, "");

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <style>
        {`
                    .rmdp-input {
                        color: #363636;
                        font-size: 16px;
                        border: 1px solid #e1e1e1;
                        border-radius: 100px;
                        height: auto;
                        padding: 11px 15px;
                        box-sizing: border-box;
                        transition: all 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                        box-shadow: none;
                        width: 100%;
                    }
                    .rmdp-input:focus {
                        border-color: #21409a;
                        box-shadow: none;
                    }
                    .rmdp-wrapper {
                        width: 100% !important;
                        box-shadow: none !important;
                        border: 1px solid #e1e1e1;
                        border-radius: 24px;
                    }
                    .rmdp-wrapper input {
                        font-size: 24px !important;
                        width: 45px !important;
                        color: #363636 !important;
                    }
                    .dvdr{
                        font-size: 35px !important;
                        color: #D9D9D9 !important;
                    }
                    `}
      </style>

      <div dir="rtl" className={`text-right mx-4 px-2 mt-1 mb-3 d-inline-block`}>
        <div className={`d-flex justify-content-between align-items-start flex-wrap my-3 py-3`}>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="exportTitle">
              عنوان گزارش
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="text"
              id="exportTitle"
              name="exportTitle"
              value={formValue.exportTitle}
              onChange={formChangeHandler}
            />
          </Form.Group>
          {/*<Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="area">منطقه</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="area" name="area" value={formValue.area} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="ownerName">نام مالک</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="ownerName" name="ownerName" value={formValue.ownerName} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="ownerPhone">شماره مالک</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="number" id="ownerPhone" name="ownerPhone" value={formValue.ownerPhone} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="code">کد ملک</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="number" id="code" name="code" value={formValue.code} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column position-relative`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="price">قیمت</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="price" name="price" value={addCommas(removeNonNumeric(formValue.price))} onChange={formChangeHandler} />
                        <Form.Text className={`${styles.form_smallText_input} position-absolute top-50 start-0 px-3`}>تومان</Form.Text>
                    </Form.Group>*/}
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="selectDate">
              انتخاب تاریخ
            </Form.Label>
            <DatePicker
              id="date"
              name="date"
              value={formValue.date}
              onChange={selectDateChangeHandler}
              calendar={persian}
              locale={persian_fa}
              format="DD MMMM YYYY"
            />
          </Form.Group>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="selectTime">
              انتخاب زمان
            </Form.Label>
            <DatePicker
              id="time"
              name="time"
              value={formValue.time}
              onChange={selectTimeChangeHandler}
              calendar={persian}
              locale={persian_fa}
              disableDayPicker
              format="HH:mm"
              plugins={[<TimePicker hideSeconds />]}
            />
          </Form.Group>

          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column w-100`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="exportResult">
              نتیجه گزارش
            </Form.Label>
            <Form.Control
              style={{ resize: "none" }}
              className={`${styles.form_control_input} shadow-none`}
              as="textarea"
              rows={9}
              id="exportResult"
              name="exportResult"
              value={formValue.exportResult}
              onChange={formChangeHandler}
            />
          </Form.Group>
        </div>

        {/* Save Btn */}
        <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center flex-wrap my-2">
          {btnLoader ? (
            <div className={Dstyles.btn_loader_container}>
              <div className={Dstyles.btn_spinner}></div>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-center my-md-0 my-2">
              <button className={styles.save_btn} type="" onClick={submitHandler}>
                ذخیره
              </button>
            </div>
          )}
        </div>
        {/* Save Btn */}
      </div>
    </>
  );

  function submitHandler() {
    if (formValue.exportResult != "" && formValue.exportTitle != "") {
      notify("درحال ثبت گزارش شما", "success");
    } else {
      notify("لطفا تمام فیلد هارا پرکنید", "error");
    }
  }

  function notify(text, type) {
    if (type === "success") {
      setBtnLoader(true);
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      addReport();
      setBtnLoader(false);
    } else if (type === "posted") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    } else if (type === "posted-error") {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    } else {
      setBtnLoader(true);
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function addReport() {
    try {
      setBtnLoader(true);
      // console.log(id)
      const { exportTitle, ownerName, ownerPhone, code, price, area, exportResult, date } = formValue;
      const reportDate = `${date.year}/${date.month.number}/${date.day}`;
      const reportTime = `${date.hour}:${date.minute}`;
      var data = new FormData();
      data.append("EstateId", id);
      data.append("ReportTitle", exportTitle);
      /*data.append('Ownername', "ownerName");
            data.append('OwnerPhoneNumber', "ownerPhone");
            data.append('EstateCode', "code");
            data.append('Price', "price");
            data.append('Area', "area");*/
      data.append("ReportResult", exportResult);
      data.append("ReportDate", reportDate);
      data.append("ReportTime", reportTime);
      const postData = await axios.post("ConsultantReport", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(postData)
      if (postData.data.isSuccess) {
        notify("گزارش با موفقیت ثبت شد", "posted");
        history.push({
          pathname: `/consultant-reports/${id}`,
          state: {
            detail: {
              id: id,
            },
          },
        });
      } else {
        notify(postData.data.metaData.message, "posted-error");
      }
      setBtnLoader(false);
    } catch (error) {
      notify("خطای سرور", "posted-error");
    }
  }
};

export default AddConsultantReportsExpertReportForm;
